import {
  CreditCard,
  Payment,
  PaymentReturn as PaymentReturn,
} from "../../core/entities/creditCard";
import { Component, OnInit, Input } from "@angular/core";
import { IpService } from "src/app/core/services/ip.service";
import { CreditCardService } from "src/app/core/services/credit-card-service";
import { ToastrService } from "ngx-toastr";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import Swal from "sweetalert2";
import { Router } from "@angular/router";
@Component({
  selector: "app-credit-card",
  templateUrl: "./credit-card.component.html",
  styleUrls: ["./credit-card.component.css"],
})
export class CreditCardComponent implements OnInit {
  form: FormGroup;
  @Input() pedido: number;
  @Input() total: number;
  @Input() currentFormaPagamento;
  @Input() onSubmit;

  creditCard: CreditCard;
  parcelas = [];
  payment: Payment;
  paymentReturn: PaymentReturn;
  processando: boolean = false;
  ipAddress: string;
  latitude: any;
  longitude: any;
  public error: Boolean = false;
  public errorMsg: String;
  public bandeira: String[] = [
    "AMEX",
    "CABAL",
    "DINERS",
    "ELO",
    "HIPER",
    "MASTERCARD",
    "VISA",
    "JCB",
  ];
  currentBandeira: string = "desconhecido";
  constructor(
    public toastService: ToastrService,
    public ipService: IpService,
    private router: Router,
    public creditCardService: CreditCardService
  ) {
    this.form = new FormGroup({
      nome: new FormControl("", [Validators.required]),
      numero: new FormControl("", [Validators.required]),
      mes: new FormControl("", [Validators.required]),
      ano: new FormControl("", [Validators.required]),
      cvv: new FormControl("", [Validators.required]),
      parcelas: new FormControl("", [Validators.required]),
      bandeira: new FormControl("", [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.GetCreditCardInstance();
    this.getIP();
    this.ConsultaPedido();
    // this.creditCard.parcelas = 1
    for (let i = 1; i <= this.currentFormaPagamento.num_maximo_parcela; i++) {
      this.parcelas.push(i);
    }
  }

  get getFilePaymentName() {
    return `Payment_Order${this.pedido}.json`;
  }

  get getFilePaymentReturnName() {
    return `PaymentReturn_Order${this.pedido}.json`;
  }

  get meses() {
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  }

  get anos() {
    return [
      2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033,
      2034, 2035, 2036,
    ];
  }

  ConsultaPedido() {
    return;

    if (this.creditCard) {
      this.paymentReturn = new PaymentReturn();

      this.creditCardService.consultaPedido(
        this.pedido,
        function (response) {
          if (
            response &&
            response.resultado &&
            response.resultado.return_message
          ) {
            this.paymentReturn.status = response.resultado.return_message;
            PaymentReturn.setSucess(this.paymentReturn);
            this.processando = false;
          }
        }.bind(this)
      );
    }
  }

  Save() {
    if (!this.form.valid) {
      this.error = true;
      this.errorMsg = "Confira o formulário corretamente!";
      return;
    }
    this.processando = true;

    this.paymentReturn = new PaymentReturn();
    if (this.creditCard) {
      this.payment = this.ToPayment(this.creditCard);
      // localStorage.setItem(
      //   this.getFilePaymentName,
      //   JSON.stringify(this.payment)
      // );
      delete this.payment.Installments;
      delete this.payment.ipAdress;
      delete this.payment.Amount;
      this.onSubmit()
        .then((resp) => {
          this.creditCardService.enviaPedido(
            { ...this.payment, pedido: this.pedido, total: this.total },
            function (response) {
              this.processando = false;
              // Swal.fire(
              //   $localize`Pedido`,
              //   $localize`Finalizado com sucesso, em andamento!`,
              //   "success"
              // );
              // this.pedidoService.unSelectAndDeleteCheckout();
              // this.onSubmit();
              Swal.fire(
                $localize`Pedido`,
                $localize`Finalizado com sucesso, em andamento!`,
                "success"
              ).then((result) => {
                if (result.isConfirmed || result.isDismissed) {
                  this.router
                    .navigate(["/pedidos"], {
                      queryParams: { page: "EM_ANDAMENTO" },
                    })
                    .then(() => {
                      window.location.reload();
                    });
                }
              });
            }.bind(this),
            function (response) {
              this.processando = false;
              this.toastService.warning(
                response.error ? response.error.detail : "Algo deu errado",
                $localize`Cliente`,
                {
                  positionClass: "toast-bottom-left",
                }
              );
              if (response.status === 403) {
                this.toastService.warning(
                  $localize`Usuario não autenticado`,
                  $localize`Cliente`,
                  {
                    positionClass: "toast-bottom-left",
                  }
                );
                this.router.navigate(["/login"]).then(() => {
                  window.location.reload();
                });
              }
            }.bind(this)
          );
        })
        .catch((err) => {
          console.error("Erro no onSubmit:", err);
          this.processando = false;

          this.toastService.warning(
            err?.message || "Erro ao finalizar o pedido",
            $localize`Cliente`,
            {
              positionClass: "toast-bottom-left",
            }
          );
        });
    }
    // this.Read();
  }

  GetCreditCardInstance() {
    // let content = localStorage.getItem(this.getFilePaymentName);

    // if (content) {
    //   this.payment = <Payment>JSON.parse(content);
    this.creditCard = this.ToCreditCard(this.payment);
    // } else {
    //   this.creditCard = new CreditCard();
    //   this.creditCard.pedido = this.pedido;
    // }
  }

  // async Read() {
  //   // let content = localStorage.getItem(this.getFilePaymentReturnName);
  //   if (content) this.paymentReturn = <PaymentReturn>JSON.parse(content);

  //   if (this.paymentReturn.sucess != undefined) {
  //     this.processando = false;
  //   }

  //   this.processando = true;

  //   await this.Sleep();

  //   this.Read();
  // }

  private delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  private async Sleep() {
    await this.delay(2000);
    // console.log("Afterp:  " + new Date().toString());
  }

  public ToCreditCard(payment: Payment): CreditCard {
    let creditCard = new CreditCard();
    creditCard.parcelas = 1;
    // creditCard.pedido = payment.merchantOrderId;
    // creditCard.nome = payment.nomeNoCartao;
    // creditCard.numero = payment.numeroCartao;
    // creditCard.validadeMes = Number(payment.dataExpiracao.substring(0, 2));
    // creditCard.validadeAno = Number(payment.dataExpiracao.substring(3, 7));
    // creditCard.codigoSeguranca = payment.cvv;

    return creditCard;
  }

  public ToPayment(creditCard: CreditCard): Payment {
    let payment = new Payment();

    payment.parcelas = this.currentFormaPagamento
      ? this.currentFormaPagamento.num_maximo_parcela
      : 1;
    payment.merchantOrderId = creditCard.pedido;
    payment.parcelas = creditCard.parcelas;
    payment.bandeira = creditCard.bandeira;
    payment.nomeNoCartao = creditCard.nome;
    payment.numeroCartao = creditCard.numero;
    payment.dataExpiracao = `${creditCard.validadeMes
      .toString()
      .padStart(2, "0")}/${creditCard.validadeAno}`;
    payment.cvv = creditCard.codigoSeguranca;
    payment.ipAdress = this.ipAddress;

    return payment;
  }

  HabilitarBotaoAutorizar() {
    // return true;

    if (!this.creditCard) return false;

    if (!this.creditCard.numero || this.creditCard.numero.length != 16)
      return false;

    // if (!this.creditCard.numero2 || this.creditCard.numero2.length != 4)
    //   return false;

    // if (!this.creditCard.numero3 || this.creditCard.numero3.length != 4)
    //   return false;

    // if (!this.creditCard.numero4 || this.creditCard.numero4.length != 4)
    //   return false;

    if (!this.creditCard.codigoSeguranca) return false;

    if (!this.creditCard.validadeAno) return false;

    if (!this.creditCard.validadeMes) return false;

    if (!this.creditCard.nome) return false;

    return (
      !this.processando &&
      (this.paymentReturn == undefined ||
        this.paymentReturn.sucess == undefined ||
        this.paymentReturn.sucess == false)
    );
  }

  HabilitarMensagemAutorizando() {
    return this.processando;
  }

  HabilitarMensagemRetorno() {
    return (
      this.paymentReturn &&
      this.paymentReturn.sucess != undefined &&
      this.paymentReturn.sucess != null
    );
  }

  getCardFlag() {
    if (this.creditCard.numero === undefined) {
      this.currentBandeira = "desconhecido";
      return;
    }
    let cardNumber = this.creditCard.numero.replace(/\s|-/g, "");

    const cardPatterns: { [key: string]: RegExp } = {
      VISA: /^4[0-9]{12}(?:[0-9]{3})?$/,
      MASTERCARD: /^5[1-5][0-9]{14}$/,
      AMEX: /^3[47][0-9]{13}$/,
      DINERS: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
      DISCOVER: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
      JCV: /^(?:2131|1800|35\d{3})\d{11}$/,
      ELO: /^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^50(4175|6699|67[0-6][0-9]|677[0-8]|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9])|^627780|^63(6297|6368|6369)|^65(0(0(3([1-3]|[5-9])|4([0-9])|5[0-1])|4(0[5-9]|[1-3][0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8]|4[1-9]|[5-8][0-9]|9[0-8])|7(0[0-9]|1[0-8]|2[0-7])|9(0[1-9]|[1-6][0-9]|7[0-8]))|16(5[2-9]|[6-7][0-9])|50(0[0-9]|1[0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/,
    };

    for (const [flag, pattern] of Object.entries(cardPatterns)) {
      if (pattern.test(cardNumber)) {
        this.currentBandeira = flag;
        return;
      }
    }

    this.currentBandeira = "desconhecido";
    return;
  }

  HabilitarEdicaoCampos() {
    return (
      !this.processando &&
      (this.paymentReturn == null ||
        this.paymentReturn.sucess == undefined ||
        this.paymentReturn.sucess == false)
    );
  }

  getIP() {
    this.ipService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  change() {
    this.getCardFlag();
    if (this.creditCard.numero.length) {
      this.creditCard.bandeira = this.currentBandeira;
    }
  }

  moveToNext(currentInput: HTMLInputElement, nextInput: HTMLInputElement) {
    if (currentInput.value.length === 4) {
      nextInput.focus();
    }
  }

  setNumero(num) {
    num = num.replace(/[^0-9\\]+/g, "");

    if (num.length == 0) return num;

    let len = 2;
    var numberWithZeroes = String(num);
    var counter = numberWithZeroes.length;

    while (counter < len) {
      numberWithZeroes = "0" + numberWithZeroes;
      counter++;
    }

    return numberWithZeroes.substring(0, 4);
  }
}
